// ====================================================================================================
// ==========                                  S T R I N G S                                 ==========
// ====================================================================================================
const messages = {
	en: {
		// -------------------------------------- Menu.vue --------------------------------------
		settings: 'Settings',
		standardRemote: 'Standard Remote',
		myRemote: 'My Remote',
		configMyRemote: 'Configure My Remote',
		configTvButtons: 'TV Control',
		learnMore: 'Learn More',
		menuLabelApp: 'Site Menu',
		menuLabel: {
			default: 'Menu',
			comcast: 'Xfinity Menu',
			cox: 'Cox Menu',
			rogers: 'Menu with Rogers logo',
			shaw: 'Menu with Shaw logo',
		},
		version: 'Version',
		changeBox: {
			default: 'Change your TV box',
			rogers: 'Change your TV player',
			shaw: 'Change your TV player',
		},
		soundCues: 'Sound Cues',

		// ----------------------------------- ChooseAuth.vue -----------------------------------                   : ,
		chooseHowToSetUp: {
			default: 'Set up your web remote',
			comcast: 'Choose how to set up your web remote',
			cox: 'Accessible Web Remote',
			rogers: 'Accessible Web Remote',
			shaw: 'Accessible Web Remote',
		},
		loginMessage: {
			default: 'Log in via web with your ID and password',
			comcast:
				'Log in via web with your Xfinity ID and password, or select Easy Pair to get a 7-digit code that you’ll enter using your handheld TV remote.',
			cox: 'Log in using your Cox User ID and Password',
			rogers: 'Log in using your MyRogers ID and Password',
			shaw: 'Log in using your Shaw ID and Password',
		},
		login: 'Log in',
		easyPair: 'Easy Pair',

		// -------------------------------- SettingsPage.vue --------------------------------
		settingsPagePrivacySettings: 'Privacy Settings',
		settingsPagePrivacyMessage: 'We use cookies and local browser storage to provide you with the best possible experience. The data we collect allows us to analyze user behavior in order to constantly improve the application for you.',
		settingsPageAcceptAll: 'Accept All',
		settingsPageAcceptSelection: 'Accept Selection',
		settingsPageRejectAll: 'Reject All',
		settingsPageNecessary: 'Necessary',
		settingsPageAnalytics: 'Analytics',
		settingsPageSave: 'Save Selection',
		settingsPageCancel: 'Cancel',

		// -------------------------------- ChooseDevicePage.vue --------------------------------
		cantSeeStbsWithoutLogin: {
			default: 'You cannot see a list of TV boxes without being logged in.',
			rogers: 'You cannot see a list of TV players without being logged in.',
			shaw: 'You cannot see a list of TV players without being logged in.',
		},

		// ----------------------------------- ErrorPage.vue ------------------------------------
		unrecoverableErrorOccurred: 'An unrecoverable error occurred',
		wereSorryErrorOccurred: 'We’re sorry. An error occurred.',
		needToRelogin: 'You need to re-login.',
		wereSorryInternalError: 'We’re sorry. An internal error occurred.',
		wereSorryUnexpectedError: 'We’re sorry. An unexpected error occurred.',
		wereSorrySomethingWeird: 'We’re sorry. Something weird happened.',
		goHome: 'Log in again',
		goBack: 'Go Back',

		// --------------------------------- LoginAgainPage.vue ---------------------------------
		loginAgain: 'Please log in again',
		needToRelogin: 'You need to re-login.',
		goHome: 'Log in again',
		goBack: 'Go Back',
		yourSessionExpired: 'Your session expired. Please log in again.',

		// --------------------------------- FourOhFourPage.vue ---------------------------------
		youSeemLost: 'You seem lost.',
		youProbablyWantToVisit: 'You probably want to visit',
		theHomePage: 'the home page',

		// -------------------------------- LoginCompletePage.vue -------------------------------
		loginError: 'Login Error',
		loginDidNotWorkProperly: 'Login did not work properly.',

		// -------------------------------- AccessibleRemote.vue --------------------------------
		appRequiresLocalStorage: 'This application requires Local Storage support.',

		// ---------------------------------- ChooseDevice.vue ----------------------------------
		selectATvBoxHeader: {
			default: 'Choose which TV Box to control',
			rogers: 'Choose which TV Player to control',
			shaw: 'Choose which TV Player to control',
		},
		selectATvBox: {
			default:
				'Select a TV Box to start using your web remote. You can change this setting later.',
			cox: 'Select a TV Box to start using your Accessible Web Remote. You can change this setting later.',
			rogers: 'Select a TV Player to start using your Accessible Web Remote. You can change this setting later.',
			shaw: 'Select a TV Player to start using your Accessible Web Remote. You can change this setting later.',
		},
		fetchingAccountInformation: 'fetching account information...',

		// ----------------------------------- PleaseWait.vue -----------------------------------
		pleaseWait: 'Please wait...',

		// ---------------------------------- WaitingForTv.vue ----------------------------------
		continueSetupWithEasyPair: 'Continue setup with the Easy Pair app',
		useRemoteThenEnterCode:
			'Use your handheld TV remote and say ’Easy Pair’ to launch the EasyPair app. Then enter this 7-digit code and select Pair Now.',

		// ------------------------------------- Remote.vue -------------------------------------
		releaseNotes: 'Release Notes',
		turnKeySoundsOn: 'Turn Key Sounds On',
		turnKeySoundsOff: 'Turn Key Sounds Off',
		bookmark: 'Bookmark',
		logout: 'Logout',
		typeAVoiceCommand: 'Type a voice command',
		remoteHeader: {
			default: 'Web Remote',
			comcast: 'Xfinity Web Remote',
			cox: 'Accessible Web Remote',
			rogers: 'Accessible Web Remote',
			shaw: 'Accessible Web Remote',
		},

		// ---------------------------------ASLInterfacePage.vue---------------------------------
		signLanguagePageHeadingLabel: 'Sign Language Remote', //Control Remoto de Lenguaje de Señas, Télécommande en Langue des Signes
		startSignRecording: 'Start Recording', //Empezar a Grabar, Commencer l'Enregistrement
		stopSignRecording: 'Stop Recording', //Para de Grabar, Arrête d'Enregistrer
		sendingSign: 'Sending Sign', //Enviando Señal, Envoi de Signe

		// --------------------------------- SeaButtonsPage.vue ---------------------------------
		seaButtonsPagePleaseWait: 'Please wait',
		seaButtonsPageErrGettingBtnData:
			'We’re sorry. An error occurred getting your customized button data. Please try again later.',
		seaButtonsPageHeadingLabel: 'My Remote',
		seaButtonsPageNoButtonsYet:
			'You haven’t configured any custom buttons yet. Click "Add button" to do so.',

		// ------------------------------ EditButtonOrderPage.vue ------------------------------
		choosePopularButtonsPageHeader: 'Add popular buttons',
		choosePopularButtonsPageDescription: "Select as many buttons as you'd like from the categories below.",
		customButtonPageHeader: 'Custom remote: Edit custom button',
		customButtonPageAddHeader: 'Custom remote: Add custom button',
		customButtonAddPageHeader: 'Add Buttons',
		customButtonPageCommandLede: "Start by adding a command with your keyboard. The label will be auto-generated but can be edited if you'd like.",
		customButtonPageImageLede: 'Select an image for your button.',
		customButtonPageLede: 'Create a custom button to suit your needs.',
		customButtonPageSave: 'Save',
		editButtonOrderPageAddItem: 'Add button',
		editButtonOrderPageAddNewButton: 'Add a new custom button',
		editButtonOrderPageAddPopularLabel: 'Popular apps, channels, accessibility settings, and more.',
		editButtonOrderPageAddPopularItems: 'Popular buttons',
		editButtonOrderPageAddCustomLabel: "Can't find what you need in popular buttons? Make your own!",
		editButtonOrderPageAddCustomItems: 'Custom buttons',
		editButtonOrderPageCancel: 'Cancel',
		editButtonOrderPageCategories: 'Popular Categories',
		editButtonOrderPageChangeImage: 'Change Image',
		editButtonOrderPageChooseImage: 'Button Image',
		editButtonOrderPageTestButton: 'Your Button',
		editButtonOrderPageChoosePopBtns: 'Choose from these popular buttons',
		editButtonOrderPageCommand: 'Command',
		editButtonOrderPageConfigError:
			'Please enter a voice command and button label, and choose an image',
		editButtonOrderPageConfirmDelete: 'Do you want to delete?',
		editButtonOrderPageDeleteItem: 'Delete button',
		editButtonOrderPageDisplayString: 'Button Label',
		editButtonOrderPageEditButton: 'Edit custom button',
		editButtonOrderPageEditItem: 'Edit',
		editButtonOrderPageEnterCommand: 'Command',
		editButtonOrderPageEnterCommandErr: 'Please enter a command',
		editButtonOrderPageEnterDispStr: 'Button label',
		editButtonOrderPageFtueHelp:
			'Add custom buttons using the "Add button" and "Popular buttons" buttons on the right.',
		editButtonOrderPageFullRemote: 'Main remote',
		editButtonOrderPageHeader: 'Edit button order',
		editButtonOrderPageMoveItemDown: 'Move button down',
		editButtonOrderPageMoveItemUp: 'Move button up',
		editButtonOrderPageNoneSelectedYet: 'None selected yet',
		editButtonOrderPageOkay: 'OK',
		editButtonOrderPagePleaseWait: 'Please wait',
		editButtonOrderPageSave: 'Save button order',
		editButtonOrderPageViewAll: 'View all',
		editButtonOrderPageYourFirstButtons:
			'Use the D-pad to change button order. The first nine buttons will appear on the main remote.',

		// ---------------------------------- TvConfigPage.vue ----------------------------------
		tvConfigPageConfigApiPlaceholder: 'Enter key here',
		tvConfigPageConfigCancel: 'Cancel',
		tvConfigPageConfigClear: 'Clear',
		tvConfigPageConfigCopyKeyLink: 'Go to IFTTT',
		tvConfigPageConfigDialogHeader: 'Configure your button',
		tvConfigPageConfigDocsLink: 'New to IFTTT? Start here',
		tvConfigPageConfigEdit: 'Edit',
		tvConfigPageConfigEditKey: 'Edit IFTTT Key',
		tvConfigPageConfigPlaceholder: 'Event name',
		tvConfigPageConfigReturn: 'Return to remote',
		tvConfigPageConfigSave: 'Save',
		tvConfigPageConfigSetup: 'Set up',
		tvConfigPageConfigTest: 'Test',
		tvConfigPageEditEventsButton: 'Edit Event Names',
		tvConfigPageEventHeading: 'Enter the event name you used when creating your applet',
		tvConfigPageEventSubHeading:
			'Your event name and IFTTT key must match what you entered on the site for the test to work.',
		tvConfigPageHeader: 'TV Control',
		tvConfigPageHeaderSetup: 'Set Up TV Buttons',
		tvConfigPageKeyGetStarted: 'Enter your IFTTT Key to get started.',
		tvConfigPageKeyLabel: 'IFTTT Key',

		// -------------------------------- AccessibleRemote.js ---------------------------------
		couldNotProcessKey: 'Sorry. I could not process the key you clicked.',
		couldNotProcessButton: 'Sorry. I could not process the button you clicked.',
		confirmationTookTooLong:
			'The confirmation process took too long. Refresh this page to try again.',
		unusualErrorConfirmingCode:
			'An unusual internal error occurred trying to confirm your pairing code.',
		internalErrorGettingCode: 'An internal error occurred trying to get a pairing code.',
		unusualErrorGettingCode: 'An unusual internal error occurred trying to get a pairing code.',
		internalErrorOccurred: 'An internal error occurred.',
		internalErrorGettingBtns:
			'An internal error occurred while trying to get Simple, Easy, Awesome Buttons.',
		internalErrorSavingBtns:
			'An internal error occurred while trying to save Simple, Easy, Awesome Buttons.',
		noCompatibleStbFound: {
			default: 'No compatible TV box found.',
			rogers: 'No compatible TV player found.',
			shaw: 'No compatible TV player found.',
		},
		internalErrorGettingDevs:
			'An internal error occurred while trying to get a list of devices for your account.',
		internalErrorGettingToken: 'An unusual internal error occurred trying to get token.',
		sessionIsNoLongerValid: 'Your session is no longer valid. You need to re-pair or login.',
		expiredEasyPairToken: 'Your EasyPair setup has expired. You need to re-pair or login.',
		internalError: 'An internal error occurred',
		internalErrorSavingCompanionPairing:
			'An internal error occurred while saving the companion pairing',

		// ------------------------------ Remote.vue ------------------------------
		accessibility: 'Accessibility',
		allPower: 'Power',
		browserAudioSupport: 'Your browser does not support the <code><audio></code> element.',
		channelDown: 'Channel Down',
		channelUp: 'Channel Up',
		exitButton: 'Exit',
		fastForward: 'Forward',
		guideButton: 'Guide',
		homeButton: 'Home',
		infoButton: 'Info',
		menuButton: 'Menu',
		muteButton: 'Mute',
		okButton: 'OK',
		pageDown: 'Page Down',
		pageUp: 'Page Up',
		playPauseButton: 'Play / Pause',
		prevButton: 'Last',
		recordButton: 'Record',
		replayButton: 'Replay',
		rewindButton: 'Rewind',
		searchButton: 'Search',
		spaceButton: 'Space',
		tvInput: 'TV Input',
		tvPower: 'TV Power',
		voiceButton: 'Voice',
		volumeDown: 'Volume Down',
		volumeUp: 'Volume Up',
		downArrow: 'down',
		leftArrow: 'left',
		rightArrow: 'right',
		upArrow: 'up',

		// ------------------------------ NewVersion.vue ------------------------------
		weveUpdated: {
			default: 'We\'ve updated Web Remote',
			comcast: 'We\'ve updated Xfinity Web Remote',
			cox: 'We\'ve updated Accessible Web Remote',
			rogers: 'We\'ve updated Accessible Web Remote',
			shaw: 'We\'ve updated Accessible Web Remote'
		},
		toGetLatestVersion: 'To get the latest version, refresh your page.',
		refresh: 'Refresh'
	},

	es: {
		// -------------------------------------- Menu.vue --------------------------------------
		settings: 'Ajustes',
		standardRemote: 'Control Remoto Estándar',
		myRemote: 'Mi Remoto',
		configMyRemote: 'Configurar Mi Remoto',
		learnMore: 'Obtener Más Información',
		menuLabelApp: 'Menú del Sitio',
		menuLabel: {
			comcast: 'Menú Xfinity',
			cox: 'Menú Cox',
			default: 'Menú',
			rogers: 'Menú Con El Logotipo De Rogers',
			shaw: 'Menú Con El Logotipo De Shaw',
		},
		version: 'Versión',
		changeBox: {
			default: 'Cambia Tu Decodificador',
			rogers: 'Cambia Tu Reproductor De TV',
			shaw: 'Cambia Tu Reproductor De TV',
		},
		soundCues: 'Señales De Sonido',

		// ----------------------------------- ChooseAuth.vue -----------------------------------
		chooseHowToSetUp: {
			comcast: 'Elige Cómo Configurar Tu Control Remoto Web',
			cox: 'Control Remoto Web Accesible',
			default: 'Configura Tu Control Remoto Web',
			rogers: 'Control Remoto Web Accesible',
			shaw: 'Control Remoto Web Accesible',
		},
		loginMessage: {
			comcast:
				'Inicia Sesión A Través De La Web Con Tu ID Y Contraseña De Xfinity O Selecciona Easy Pair Para Obtener Un Código De 7 Dígitos Que Ingresarás Usando El Control Remoto De Tu TV Portátil.',
			cox: 'Inicia Sesión Con Tu Identificación De Usuario Y Contraseña De Cox',
			default: 'Inicia Sesión A Través De La Web Con Tu Identificación Y Contraseña',
			rogers: 'Inicia Sesión Con Tu Identificación Y Contraseña De MyRogers',
			shaw: 'Inicia Sesión Con Tu Identificación Y Contraseña De Shaw',
		},
		login: 'Iniciar Sesión',
		easyPair: 'Easy Pair',

		// -------------------------------- SettingsPage.vue --------------------------------
		settingsPagePrivacySettings: 'La Configuración de Privacidad',
		settingsPagePrivacyMessage: 'Utilizamos cookies y almacenamiento del navegador local para brindarle la mejor experiencia posible. Los datos que recopilamos nos permiten analizar el comportamiento del usuario para mejorar constantemente la aplicación para usted.',
		settingsPageAcceptAll: 'Aceptar Todo',
		settingsPageAcceptSelection: 'Aceptar la Selección',
		settingsPageRejectAll: 'Rechazar Todo',
		settingsPageNecessary: 'Necesario',
		settingsPageAnalytics: 'Analítica',
		settingsPageSave: 'Guardar Selección',
		settingsPageCancel: 'Cancelar',

		// -------------------------------- ChooseDevicePage.vue --------------------------------
		cantSeeStbsWithoutLogin: {
			default: 'No Puedes Ver Una Lista De Cajas De TV Sin Haber Iniciado Sesión.',
			rogers: 'No Puedes Ver Una Lista De Reproductores De TV Sin Haber Iniciado Sesión.',
			shaw: 'No Puedes Ver Una Lista De Reproductores De TV Sin Haber Iniciado Sesión.',
		},

		// ----------------------------------- ErrorPage.vue ------------------------------------
		unrecoverableErrorOccurred: 'Se Produjo Un Error Irrecuperable',
		wereSorryErrorOccurred: 'Lo Sentimos. Se Ha Producido Un Error.',
		needToRelogin: 'Es Necesario Volver A Iniciar Sesión.',
		wereSorryInternalError: 'Lo Sentimos. Se Ha Producido Un Error Interno.',
		wereSorryUnexpectedError: 'Lo Sentimos. Se Produjo Un Error Inesperado.',
		wereSorrySomethingWeird: 'Lo Sentimos. Algo Extraño Sucedió.',
		goHome: 'Inicia Sesión De Nuevo',
		goBack: 'Volver',
		yourSessionExpired: 'Tu Sesión Ha Expirado. Inicia Sesión De Nuevo.',

		// --------------------------------- LoginAgainPage.vue ---------------------------------
		loginAgain: 'Por Favor Inicia Sesión Nuevamente',
		needToRelogin: 'Es Necesario Volver A Iniciar Sesión.',
		goHome: 'Inicia Sesión De Nuevo',
		goBack: 'Volver',
		yourSessionExpired: 'Tu Sesión Ha Expirado. Inicia Sesión De Nuevo.',

		// --------------------------------- FourOhFourPage.vue ---------------------------------
		youSeemLost: 'Te Ves Perdido.',
		youProbablyWantToVisit: 'Es Probable Que Desees Visitar',
		theHomePage: 'La Página De Inicio',

		// -------------------------------- LoginCompletePage.vue -------------------------------
		loginError: 'Error De Inicio De Sesión',
		loginDidNotWorkProperly: 'El Inicio De Sesión No Funcionó Correctamente.',

		// -------------------------------- AccessibleRemote.vue --------------------------------
		appRequiresLocalStorage: 'Esta Aplicación Requiere Soporte De Almacenamiento Local. ',

		// ---------------------------------- ChooseDevice.vue ----------------------------------
		selectATvBoxHeader: {
			cox: 'Selecciona Qué Decodificador Controlar',
			default: 'Selecciona Qué Decodificador Controlar',
			rogers: 'Selecciona Qué Reproductor De TV Controlar',
			shaw: 'Selecciona Qué Reproductor De TV Controlar',
		},
		selectATvBox: {
			cox: 'Selecciona Un Decodificador Para Comenzar A Usar El Control Remoto Web. Puedes Cambiar Esta Configuración Más Adelante.',
			default:
				'Selecciona Un Decodificador Para Comenzar A Usar Tu Control Remoto Web. Puedes Cambiar Esta Configuración Más Adelante.',
			rogers: 'Selecciona Un Reproductor De TV Para Comenzar A Usar El Control Remoto Web. Puedes Cambiar Esta Configuración Más Adelante.',
			shaw: 'Selecciona Un Reproductor De TV Para Comenzar A Usar El Control Remoto Web. Puedes Cambiar Esta Configuración Más Adelante.',
		},
		fetchingAccountInformation: 'Buscando La Información De La Cuenta...',

		// ----------------------------------- PleaseWait.vue -----------------------------------
		pleaseWait: 'Espera...',

		// ---------------------------------- WaitingForTv.vue ----------------------------------
		continueSetupWithEasyPair: 'Continuar La Configuración Con La Aplicación Easy Pair',
		useRemoteThenEnterCode:
			'Utiliza El Control Remoto De Tu Televisor Portátil Y Di ‘Easy Pair’ Para Ejecutar La Aplicación Easypair. Luego Ingresa Este Código De 7 Dígitos Y Selecciona Pair Now (Emparejar Ahora).',

		// ------------------------------------- Remote.vue -------------------------------------
		releaseNotes: 'Notas De La Versión',
		turnKeySoundsOn: 'Activar Los Sonidos De La Llave',
		turnKeySoundsOff: 'Desactivar Los Sonidos De La Llave',
		bookmark: 'Marcador',
		logout: 'Cerrar Sesión',
		typeAVoiceCommand: 'Escribe Un Comando De Voz',
		remoteHeader: {
			comcast: 'Control Remoto Web Xfinity',
			cox: 'Control Remoto Web Accesible',
			default: 'Control Remoto Web',
			rogers: 'Control Remoto Web Accesible',
			shaw: 'Control Remoto Web Accesible',
		},

		// ---------------------------------ASLInterfacePage.vue---------------------------------
		signLanguagePageHeadingLabel: 'Control Remoto de Lenguaje de Señas',
		startSignRecording: 'Empezar a Grabar',
		stopSignRecording: 'Para de Grabar',
		sendingSign: 'Enviando Señal',

		// --------------------------------- SeaButtonsPage.vue ---------------------------------
		seaButtonsPagePleaseWait: 'Espera',
		seaButtonsPageErrGettingBtnData:
			'Lo Sentimos. Se Produjo Un Error Al Obtener Los Datos Del Botón Personalizado. Inténtalo Nuevamente Más Tarde.',
		seaButtonsPageHeadingLabel: 'Mi Remoto',
		seaButtonsPageNoButtonsYet:
			'Todavía No Has Configurado Ningún Botón Personalizado. Utiliza "Configure My Remote” (Configurar Mi Control Remoto) En El Menú Para Hacerlo.',

		// ------------------------------ EditButtonOrderPage.vue ------------------------------
		editButtonOrderPageHeader: 'Editar orden de botones',
		editButtonOrderPageConfirmDelete: '¿Quieres Eliminar?',
		editButtonOrderPageChooseImage: 'Seleccionar Una Imagen',
		editButtonOrderPageConfigError:
			'Introduce Un Comando De Voz Y La Etiqueta Del Botón Y Selecciona Una Imagen',
		editButtonOrderPageAddNewButton: 'Añadir Un Nuevo Botón Personalizado',
		editButtonOrderPageEditButton: 'Editar Botón Personalizado',
		editButtonOrderPageEnterCommand: 'Introducir Con El Comando De Voz',
		editButtonOrderPageEnterDispStr: 'Introduce La Etiqueta Del Botón',
		editButtonOrderPageEnterCommandErr: 'Introduce Un Comando',
		editButtonOrderPagePleaseWait: 'Espera',
		editButtonOrderPageChangeImage: 'Cambiar Imagen',
		editButtonOrderPageOkay: 'Aceptar',
		editButtonOrderPageYourFirstButtons:
			'Usa la cruceta para cambiar el orden de los botones. Los primeros nueve botones aparecerán en el control remoto principal.',
		editButtonOrderPageNoneSelectedYet: 'Ninguno Seleccionado Todavía',
		editButtonOrderPageFtueHelp:
			'Añade Botones Personalizados Usando Los Botones "Add Button” (Añadir Botón) Y "Popular Buttons" (Botones Populares) A La Derecha.',
		editButtonOrderPageAddPopularItems: 'Botones Populares',
		editButtonOrderPageCommand: 'Comando',
		editButtonOrderPageDisplayString: 'Etiqueta De Botón',
		editButtonOrderPageMoveItemUp: 'Mueve El Botón Hacia Arriba',
		editButtonOrderPageMoveItemDown: 'Mueve El Botón Hacia Abajo',
		editButtonOrderPageDeleteItem: 'Eliminar Botón.',
		editButtonOrderPageAddItem: 'Añadir Botón',
		editButtonOrderPageEditItem: 'Editar',
		editButtonOrderPageSave: 'Guardar el orden',
		editButtonOrderPageCancel: 'Cancelar',
		editButtonOrderPageChoosePopBtns: 'Choose from these popular buttons',
		editButtonOrderPageCategories: 'Categorías Populares',

		// ---------------------------------- TvConfigPage.vue ----------------------------------
		tvConfigPageConfigApiPlaceholder: 'Introduzca la clave aquí',
		tvConfigPageConfigCancel: 'Cancelar',
		tvConfigPageConfigClear: 'Borrar',
		tvConfigPageConfigCopyKeyLink: 'Ir a IFTTT',
		tvConfigPageConfigDialogHeader: 'Configura tu botón',
		tvConfigPageConfigDocsLink: '¿Nuevo al IFTTT? Empieza aqui',
		tvConfigPageConfigEdit: 'Editar',
		tvConfigPageConfigEditKey: 'Editar la clave IFTTT',
		tvConfigPageConfigPlaceholder: 'Nombre del evento',
		tvConfigPageConfigReturn: 'Volver al remoto',
		tvConfigPageConfigSave: 'Guardar',
		tvConfigPageConfigSetup: 'Configurar',
		tvConfigPageConfigTest: 'Probar',
		tvConfigPageEditEventsButton: 'Edite Nombres de los Eventos',
		tvConfigPageEventHeading: 'Ingrese el nombre del evento que usó al crear su applet',
		tvConfigPageEventSubHeading:
			'El nombre de su evento y la clave IFTTT deben coincidir con lo que ingresó en el sitio para que la prueba funcione.',
		tvConfigPageHeader: 'TV Control',
		tvConfigPageHeaderSetup: 'Configurar Botones de TV',
		tvConfigPageKeyGetStarted: 'Ingrese su clave IFTTT para comenzar.',
		tvConfigPageKeyLabel: 'Clave IFTTT',

		// -------------------------------- AccessibleRemote.js ---------------------------------
		couldNotProcessKey: 'Lo Siento. No Pude Procesar La Llave En La Que Hiciste Clic.',
		couldNotProcessButton: 'Lo Siento. No Pude Procesar El Botón En El Que Hiciste Clic.',
		confirmationTookTooLong:
			'El Proceso De Confirmación Tomó Demasiado Tiempo. Actualizar Esta Página Para Intentarlo De Nuevo.',
		unusualErrorConfirmingCode:
			'Se Produjo Un Error Interno Inusual Al Intentar Confirmar Tu Código De Emparejamiento.',
		internalErrorGettingCode:
			'Se Produjo Un Error Interno Al Intentar Obtener Un Código De Emparejamiento.',
		unusualErrorGettingCode:
			'Se Produjo Un Error Interno Inusual Al Intentar Obtener Un Código De Emparejamiento.',
		internalErrorOccurred: 'Se Ha Producido Un Error Interno.',
		internalErrorGettingBtns:
			'Se Produjo Un Error Interno Al Intentar Obtener Los Botones Simple Easy Awesome.',
		internalErrorSavingBtns:
			'Se Produjo Un Error Interno Al Intentar Guardar Los Botones Simple Easy Awesome.',
		noCompatibleStbFound: {
			default: 'No Se Encontró Ningún Decodificador Compatible.',
			rogers: 'No Se Encontró Ningún Reproductor De TV Compatible.',
			shaw: 'No Se Encontró Ningún Reproductor De TV Compatible.',
		},
		internalErrorGettingDevs:
			'Se Produjo Un Error Interno Al Intentar Obtener Una Lista De Dispositivos Para Tu Cuenta.',
		internalErrorGettingToken: 'Se Produjo Un Error Interno Inusual Al Intentar Obtener Token.',
		sessionIsNoLongerValid:
			'Tu Sesión Ya No Es Válida. Es Necesario Volver A Conectar O Iniciar Sesión.',
		expiredEasyPairToken:
			'Tu Configuración De Easypair Ha Caducado. Es Necesario Volver A Conectar O Iniciar Sesión.',
		internalError: 'Se Produjo Un Error Interno',
		internalErrorSavingCompanionPairing:
			'Se Produjo Un Error Interno Mientras Se Guardaba El Emparejamiento Complementario',

		// ------------------------------ Remote.vue ------------------------------
		accessibility: 'Accesibilidad',
		allPower: 'Encendido',
		browserAudioSupport: 'Tu Navegador No Admite El Elemento <code><audio></code>.',
		channelDown: 'Canal Abajo',
		channelUp: 'Canal Arriba',
		exitButton: 'Salir',
		fastForward: 'Avance Rápido',
		homeButton: 'Hogar',
		guideButton: 'Guía',
		infoButton: 'Info',
		menuButton: 'Menú',
		muteButton: 'Silencio',
		okButton: 'OK',
		pageDown: 'Página Abajo',
		pageUp: 'Página Arriba',
		playPauseButton: 'Reproducir / Pausar',
		prevButton: 'Último',
		recordButton: 'Grabar',
		replayButton: 'Volver A Reproducir',
		rewindButton: 'Retroceder',
		searchButton: 'Buscar',
		spaceButton: 'Espacio',
		tvInput: 'Entrada De TV',
		tvPower: 'Encendido De TV',
		voiceButton: 'Voz',
		volumeDown: 'Bajar Volumen',
		volumeUp: 'Subir Volumen',
		downArrow: 'abajo',
		leftArrow: 'izquierda',
		rightArrow: 'derecha',
		upArrow: 'arriba',

		// ------------------------------ NewVersion.vue ------------------------------
		weveUpdated: {
			default: 'Hemos actualizado Web Remote',
			comcast: 'Hemos actualizado Xfinity Web Remote',
			cox: 'Hemos actualizado Accessible Web Remote',
			rogers: 'Hemos actualizado Accessible Web Remote',
			shaw: 'Hemos actualizado Accessible Web Remote'
		},
		toGetLatestVersion: 'Para obtener la última versión, actualice su página.',
		refresh: 'Refrescar'
	},

	fr: {
		// -------------------------------------- Menu.vue --------------------------------------
		settings: 'Paramètres',
		standardRemote: 'Télécommande Standard',
		myRemote: 'Ma Télécommande',
		configMyRemote: 'Configurer My Remote',
		learnMore: 'En Savoir Plus',
		menuLabelApp: 'Menu du Site',
		menuLabel: {
			comcast: 'Menu Xfinity',
			cox: 'Menu Cox',
			default: 'Menu',
			rogers: 'Menu Avec Le Logo Rogers',
			shaw: 'Menu Avec Le Logo Shaw',
		},
		version: 'Version',
		changeBox: {
			default: 'Changer De Terminal',
			rogers: 'Changer De Lecteur De Lecteur De Télévision',
			shaw: 'Changer De Lecteur De Lecteur De Télévision',
		},
		soundCues: 'Signaux Sonores',

		// ----------------------------------- ChooseAuth.vue -----------------------------------
		chooseHowToSetUp: {
			comcast: 'Choisir Comment Configurer Votre Télécommande Web',
			cox: 'Accessible Web Remote',
			default: 'Configurer Votre Télécommande Web',
			rogers: 'Accessible Web Remote',
			shaw: 'Accessible Web Remote',
		},
		loginMessage: {
			comcast:
				'Connectez-Vous Sur Le Web À L’aide De Votre Identifiant Et Mot De Passe Xfinity, Ou Sélectionnez Easy Pair Pour Obtenir Un Code À 7 Chiffres À Saisir Avec Votre Télécommande De Télévision.',
			cox: 'Connectez-Vous À L’aide De Votre Identifiant Et Mot De Passe Cox.',
			default: 'Connectez-Vous Via Internet À L’aide De Votre Identifiant Et Mot De Passe',
			rogers: 'Connectez-Vous À L’aide De Votre Identifiant Et Mot De Passe MyRogers',
			shaw: 'Connectez-Vous À L’aide De Votre Identifiant Et Mot De Passe Shaw',
		},
		login: 'Ouvrir Une Session',
		easyPair: 'Easy Pair',

		// -------------------------------- SettingsPage.vue --------------------------------
		settingsPagePrivacySettings: 'Paramètres de Confidentialité',
		settingsPagePrivacyMessage: 'Nous utilisons des cookies et le stockage local du navigateur pour vous offrir la meilleure expérience possible. Les données que nous collectons nous permettent d\'analyser le comportement des utilisateurs afin d\'améliorer constamment l\'application pour vous.',
		settingsPageAcceptAll: 'Accepter Tout',
		settingsPageAcceptSelection: 'Accepter la Sélection',
		settingsPageRejectAll: 'Rejeter Tout',
		settingsPageNecessary: 'Nécessaire',
		settingsPageAnalytics: 'Analytique',
		settingsPageSave: 'Enregistrer la Sélection',
		settingsPageCancel: 'Annuler',

		// -------------------------------- ChooseDevicePage.vue --------------------------------
		cantSeeStbsWithoutLogin: {
			default: 'La Liste Des Terminaux S’affichera Uniquement Si Vous Êtes Connecté.',
			rogers: 'Vous Ne Pouvez Pas Voir Une Liste De Lecteurs De Télévision Sans Être Connecté.',
			shaw: 'Vous Ne Pouvez Pas Voir Une Liste De Lecteurs De Télévision Sans Être Connecté.',
		},
		// ----------------------------------- ErrorPage.vue ------------------------------------
		unrecoverableErrorOccurred: 'Une Erreur Irrécupérable S’est Produite',
		wereSorryErrorOccurred: 'Nous Sommes Désolés. Une Erreur S’est Produite.',
		needToRelogin: 'Vous Devez Vous Reconnecter.',
		wereSorryInternalError: 'Nous Sommes Désolés. Une Erreur Interne S’est Produite.',
		wereSorryUnexpectedError: 'Nous Sommes Désolés. Une Erreur Inattendue S’est Produite.',
		wereSorrySomethingWeird: 'Nous Sommes Désolés. Quelque Chose D’étrange S’est Produit.',
		goHome: 'Ouvrir Une Nouvelle Session',
		goBack: 'Retour',
		yourSessionExpired: 'Votre Session A Expiré. Veuillez Ouvrir Une Nouvelle Session.',

		// --------------------------------- LoginAgainPage.vue ---------------------------------
		loginAgain: 'Veuillez Vous Reconnecter',
		needToRelogin: 'Vous Devez Vous Reconnecter.',
		goHome: 'Ouvrir Une Nouvelle Session',
		goBack: 'Retour',
		yourSessionExpired: 'Votre Session A Expiré. Veuillez Ouvrir Une Nouvelle Session.',

		// --------------------------------- FourOhFourPage.vue ---------------------------------
		youSeemLost: 'Vous Avez L’air Perdu.',
		youProbablyWantToVisit: 'Vous Voudrez Probablement Consulter',
		theHomePage: 'La Page D’accueil',
		// -------------------------------- LoginCompletePage.vue -------------------------------
		loginError: 'Erreur De Connexion',
		loginDidNotWorkProperly: 'L’ouverture De Session N’a Pas Fonctionné Correctement.',

		// -------------------------------- AccessibleRemote.vue --------------------------------
		appRequiresLocalStorage: 'Cette Application Nécessite Un Support De Stockage Local.',

		// ---------------------------------- ChooseDevice.vue ----------------------------------
		selectATvBoxHeader: {
			cox: 'Choisir Le Terminal À Contrôler',
			default: 'Choisir Le Terminal À Contrôler',
			rogers: 'Choisir Le Lecteur De Télévision À Contrôler',
			shaw: 'Choisir Le Lecteur De Télévision À Contrôler',
		},
		selectATvBox: {
			cox: 'Sélectionner Un Terminal Pour Commencer À Utiliser Votre Service Accessible Web Remote. Vous Pourrez Modifier Ce Paramètre Plus Tard.',
			default:
				'Sélectionner Un Terminal Pour Commencer À Utiliser Votre Télécommande Web. Vous Pourrez Modifier Ce Paramètre Plus Tard.',
			rogers: 'Sélectionner Un Lecteur De Télévision Pour Commencer À Utiliser Votre Service Accessible Web Remote. Vous Pourrez Modifier Ce Paramètre Plus Tard.',
			shaw: 'Sélectionner Un Lecteur De Télévision Pour Commencer À Utiliser Votre Service Accessible Web Remote. Vous Pourrez Modifier Ce Paramètre Plus Tard.',
		},
		fetchingAccountInformation: 'Extraction De Renseignements Sur Le Compte...',

		// ----------------------------------- PleaseWait.vue -----------------------------------
		pleaseWait: 'Veuillez Patienter...',

		// ---------------------------------- WaitingForTv.vue ----------------------------------
		continueSetupWithEasyPair: 'Poursuivre La Configuration Avec L’application Easy Pair',
		useRemoteThenEnterCode:
			'Utilisez La Télécommande Mains Libres De Votre Téléviseur Et Dites « Easy Pair » Pour Lancer L’application. Entrez Ensuite Le Code À 7 Chiffres Et Sélectionnez Pair Now.',

		// ------------------------------------- Remote.vue -------------------------------------
		releaseNotes: 'Notes De Version',
		turnKeySoundsOn: 'Activer Le Son',
		turnKeySoundsOff: 'Désactiver Le Son',
		bookmark: 'Signet',
		logout: 'Déconnexion',
		typeAVoiceCommand: 'Saisir Une Commande Vocale',
		remoteHeader: {
			comcast: 'Télécommande Web Xfinity',
			cox: 'Accessible Web Remote',
			default: 'Télécommande Web',
			rogers: 'Accessible Web Remote',
			shaw: 'Accessible Web Remote',
		},
		// ---------------------------------ASLInterfacePage.vue---------------------------------
		signLanguagePageHeadingLabel: 'Télécommande en Langue des Signes',
		startSignRecording: 'Commencer l’Enregistrement',
		stopSignRecording: 'Arrête d’Enregistrer',
		sendingSign: 'Envoi de Signe',

		// --------------------------------- SeaButtonsPage.vue ---------------------------------
		seaButtonsPagePleaseWait: 'Veuillez Patienter',
		seaButtonsPageErrGettingBtnData:
			'Nous Sommes Désolés. Une Erreur S’est Produite Lors De L’obtention Des Données De Vos Touches Personnalisées. Veuillez Réessayer Plus Tard.',
		seaButtonsPageHeadingLabel: 'Ma Télécommande',
		seaButtonsPageNoButtonsYet:
			'Vous N’avez Pas Encore Configuré De Touches Personnalisées. Utilisez « Configurer My Remote » Dans Le Menu Pour Le Faire.',

		// ------------------------------ EditButtonOrderPage.vue ------------------------------
		editButtonOrderPageHeader: "Modifier l'ordre des boutons",
		editButtonOrderPageConfirmDelete: 'Voulez-Vous Supprimer?',
		editButtonOrderPageChooseImage: 'Choisir L’image',
		editButtonOrderPageConfigError:
			'Veuillez Saisir Une Commande Vocale Et Nommer La Touche, Ensuite Choisissez Une Image',
		editButtonOrderPageAddNewButton: 'Ajouter Une Touche Personnalisée',
		editButtonOrderPageEditButton: 'Modifier La Touche Personnalisée',
		editButtonOrderPageEnterCommand: 'Saisir La Commande Vocale',
		editButtonOrderPageEnterDispStr: 'Entrer Le Nom De La Touche',
		editButtonOrderPageEnterCommandErr: 'Veuillez Entrer Une Commande',
		editButtonOrderPagePleaseWait: 'Veuillez Patienter',
		editButtonOrderPageChangeImage: 'Changer L’image',
		editButtonOrderPageOkay: 'OK',
		editButtonOrderPageYourFirstButtons:
			"Utilisez le croix directionnelle pour modifier l'ordre des boutons. Les neuf premiers boutons apparaîtront sur la télécommande principale.",
		editButtonOrderPageNoneSelectedYet: 'Aucune Touche Sélectionnée Pour L’instant',
		editButtonOrderPageFtueHelp:
			'Ajouter Des Touches Personnalisées À L’aide Des Touches « Ajouter » Et « Touches Couramment Utilisées » À Droite.',
		editButtonOrderPageAddPopularItems: 'Touches Couramment Utilisées',
		editButtonOrderPageCommand: 'Commande',
		editButtonOrderPageDisplayString: 'Nom De La Touche',
		editButtonOrderPageMoveItemUp: 'Déplacer La Touche Vers Le Haut',
		editButtonOrderPageMoveItemDown: 'Déplacer La Touche Vers Le Bas',
		editButtonOrderPageDeleteItem: 'Supprimer La Touche',
		editButtonOrderPageAddItem: 'Ajouter Une Touche',
		editButtonOrderPageEditItem: 'Modifier',
		editButtonOrderPageSave: "Enregistrer l'ordre",
		editButtonOrderPageCancel: 'Annuler',
		editButtonOrderPageChoosePopBtns: 'Choisir Parmi Ces Touches Couramment Utilisées',
		editButtonOrderPageCategories: 'Catégories Populaires',

		// ---------------------------------- TvConfigPage.vue ----------------------------------
		tvConfigPageConfigApiPlaceholder: 'Entrez la clé ici',
		tvConfigPageConfigCancel: 'Annuler',
		tvConfigPageConfigClear: 'Effacer',
		tvConfigPageConfigCopyKeyLink: 'Aller sur le IFTTT',
		tvConfigPageConfigDialogHeader: 'Configurez votre bouton',
		tvConfigPageConfigDocsLink: 'Nouveau à IFTTT? Commencer ici',
		tvConfigPageConfigEdit: 'Modifier',
		tvConfigPageConfigEditKey: 'Modifier la clé IFTTT',
		tvConfigPageConfigPlaceholder: "Nom de l'événement",
		tvConfigPageConfigReturn: 'Retour à la télécommande',
		tvConfigPageConfigSave: 'Enregistrer',
		tvConfigPageConfigSetup: 'Configurer',
		tvConfigPageConfigTest: 'Tester',
		tvConfigPageEditEventsButton: 'Modifier des Événements',
		tvConfigPageEventHeading:
			"Entrez le nom de l'événement que vous avez utilisé lors de la création de votre applet",
		tvConfigPageEventSubHeading:
			'Le nom de votre événement et la clé IFTTT doivent correspondre à ce que vous avez entré sur le site pour que le test fonctionne.',
		tvConfigPageHeader: 'TV Contrôle',
		tvConfigPageHeaderSetup: 'Configurer les Boutons de la TV',
		tvConfigPageKeyGetStarted: 'Entrez votre clé IFTTT pour commencer.',
		tvConfigPageKeyLabel: 'Clé IFTTT',

		// -------------------------------- AccessibleRemote.js ---------------------------------
		couldNotProcessKey:
			'Navré. Je N’ai Pas Réussi À Traiter La Touche Sur Laquelle Vous Avez Appuyé.',
		couldNotProcessButton:
			'Navré. Je N’ai Pas Réussi À Traiter La Touche Sur Lequel Vous Avez Cliqué.',
		confirmationTookTooLong:
			'Le Processus De Confirmation A Pris Trop De Temps. Rafraîchissez Cette Page Pour Réessayer.',
		unusualErrorConfirmingCode:
			'Une Erreur Interne Inhabituelle S’est Produite Durant La Tentative De Validation Du Code De Jumelage.',
		internalErrorGettingCode:
			'Une Erreur Interne S’est Produite Durant La Tentative De Récupération Du Code De Jumelage.',
		unusualErrorGettingCode:
			'Une Erreur Interne Inhabituelle S’est Produite Durant La Tentative De Récupération Du Code De Jumelage.',
		internalErrorOccurred: 'Une Erreur Interne S’est Produite.',
		internalErrorGettingBtns:
			'Une Erreur Interne S’est Produite Durant La Tentative De Récupération Des Touches Simple, Easy Et Awesome.',
		internalErrorSavingBtns:
			'Une Erreur Interne S’est Produite Durant La Tentative D’enregistrement Des Boutons Simple, Easy Et Awesome,.',
		noCompatibleStbFound: {
			default: 'Aucun Terminal Compatible Trouvé.',
			rogers: 'Aucun Lecteur De Télévision Compatible Trouvé.',
			shaw: 'Aucun Lecteur De Télévision Compatible Trouvé.',
		},
		internalErrorGettingDevs:
			'Une Erreur Interne S’est Produite Durant La Tentative De Récupération De La Liste D’appareils De Votre Compte.',
		internalErrorGettingToken:
			'Une Erreur Interne Inhabituelle S’est Produite Durant La Tentative De Récupération Du Jeton.',
		sessionIsNoLongerValid:
			'Votre Session N’est Plus Valide. Vous Devez Effectuer Un Nouveau Jumelage Ou Ouvrir Une Session.',
		expiredEasyPairToken:
			'Votre Configuration Easypair A Expiré. Vous Devez Effectuer Un Nouveau Jumelage Ou Ouvrir Une Session.',
		internalError: 'Une Erreur Interne S’est Produite',
		internalErrorSavingCompanionPairing:
			'Une Erreur Interne S’est Produite Durant L’enregistrement Du Jumelage Du Compagnon',

		// ------------------------------ Remote.vue ------------------------------
		accessibility: 'Accessibilité',
		allPower: 'Alimentation',
		browserAudioSupport:
			'Votre Navigateur Ne Prend Pas En Charge L’élément <Code><Audio></Code>.',
		channelDown: 'Chaîne Suivante',
		channelUp: 'Chaîne Précédente',
		exitButton: 'Quitter',
		fastForward: 'Avancer',
		guideButton: 'Guide',
		homeButton: 'Accueil',
		infoButton: 'Info',
		menuButton: 'Menu',
		muteButton: 'Désactiver Le Son',
		okButton: 'OK',
		pageDown: 'Page Suivante',
		pageUp: 'Page Précédente',
		playPauseButton: 'Lecture/Pause',
		prevButton: 'Plus Récent',
		recordButton: 'Enregistrer',
		replayButton: 'Rejouer Du Début',
		rewindButton: 'Recul',
		searchButton: 'Recherche',
		spaceButton: 'Espace',
		tvInput: 'Entrée TV',
		tvPower: 'Alimentation TV',
		voiceButton: 'Voix',
		volumeDown: 'Volume Baissé',
		volumeUp: 'Volume Augmenté',
		downArrow: 'vers le bas',
		leftArrow: 'à gauche',
		rightArrow: 'à droite',
		upArrow: 'vers le haut',

		// ------------------------------ NewVersion.vue ------------------------------
		weveUpdated: {
			default: 'Nous avons mis à jour Web Remote',
			comcast: 'Nous avons mis à jour Xfinity Web Remote',
			cox: 'Nous avons mis à jour Accessible Web Remote',
			rogers: 'Nous avons mis à jour Accessible Web Remote',
			shaw: 'Nous avons mis à jour Accessible Web Remote'
		},
		toGetLatestVersion: 'Pour obtenir la dernière version, actualisez votre page.',
		refresh: 'Rafraîchir'
	}
};
// ====================================================================================================

module.exports = messages;
